import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeItem, Label } from 'src/app/interfaces/label';

@Component({
  selector: 'app-tree-item',
  templateUrl: './tree-item.component.html',
  styleUrls: ['./tree-item.component.scss'],
})
export class TreeItemComponent implements OnInit {

  @Input() level: number = 0;
  @Input() item?: TreeItem;

  @Output() onSelected: EventEmitter<Label> = new EventEmitter<Label>();
  @Output() onSelectSeries: EventEmitter<TreeItem> = new EventEmitter<TreeItem>();

  showLabels: boolean = false;

  constructor() { }

  ngOnInit() { }

  public selectLabel(label: Label) {
    this.onSelected.emit(label);
  }

  public itemClicked() {
    if (this.item?.visualization_type == 'SERIES') this.onSelectSeries.emit(this.item);
    else this.showLabels = !this.showLabels;
  }

}
